import { Box, type BoxProps } from '@mui/material'

import { color } from '@/v2/design-system/tokens'

/** Superficie para la prioridad ejecutiva dominante (ExecutivePriority,
 * Fase 3) — barra lateral de color crítico + tinte de fondo, mismo patrón
 * ya construido para esa pieza en el Centro de Inteligencia actual,
 * formalizado aquí. El color depende del nivel real (se pasa por prop),
 * `critical` es solo el valor por defecto del tinte de fondo. */
export function CriticalSurface({
  accentColor = color.critical,
  sx,
  ...props
}: BoxProps & { accentColor?: string }) {
  return (
    <Box
      sx={{
        borderLeft: `4px solid ${accentColor}`,
        borderRadius: 1.5,
        bgcolor: color.surfaceElevated,
        px: 2.5,
        py: 2,
        ...sx,
      }}
      {...props}
    />
  )
}
